import useComet from "./useComet";

function useWatch() {
  useComet("watches", "", watch => watch);
}

export { useWatch as default };
